export enum QuotePartUpdateBulkField {
  MANUFACTURER = 'manufacturer',
  MARGIN = 'margin',
  PRICE = 'price',
  PRICE_BASED_ON = 'priceBasedOn',
  PRICE_DECIMALS = 'priceDecimals',
  PRICING_DATE = 'pricingDate',
  PRICING_STRATEGY = 'pricingStrategy',
  PRIORITIZE_LEGACY_COST = 'prioritizeLegacyCost',
  PURCHASE_COST = 'purchaseCost',
  QUANTITY = 'quantity',
  REPLACEMENT_COST = 'replacementCost',
  REPLACEMENT_COST_NUMBER = 'replacementCostNumber',
  SHIPMENT_TYPE = 'shipmentType',
  SHIPPING_LOCATION = 'corporateLocation',
  TAXONOMY = 'taxonomy',
  UOM = 'uom',
  VENDOR_QUOTE_NUMBER = 'vendorQuoteNumber',
}

export const QUOTE_PART_UPDATE_BULK_FIELD_ORDER: QuotePartUpdateBulkField[] = [
  QuotePartUpdateBulkField.UOM,
  QuotePartUpdateBulkField.QUANTITY,
  QuotePartUpdateBulkField.PURCHASE_COST,
  QuotePartUpdateBulkField.VENDOR_QUOTE_NUMBER,
  QuotePartUpdateBulkField.PRIORITIZE_LEGACY_COST,
  QuotePartUpdateBulkField.PRICE,
  QuotePartUpdateBulkField.MARGIN,
  QuotePartUpdateBulkField.PRICE_BASED_ON,
  QuotePartUpdateBulkField.PRICE_DECIMALS,
  QuotePartUpdateBulkField.SHIPPING_LOCATION,
  QuotePartUpdateBulkField.SHIPMENT_TYPE,
  QuotePartUpdateBulkField.MANUFACTURER,
  QuotePartUpdateBulkField.TAXONOMY,
  QuotePartUpdateBulkField.REPLACEMENT_COST,
  QuotePartUpdateBulkField.REPLACEMENT_COST_NUMBER,
  QuotePartUpdateBulkField.PRICING_DATE,
  QuotePartUpdateBulkField.PRICING_STRATEGY,
];
